import React from 'react'
import PropTypes from 'prop-types'
import JisrLoader from 'components/global/JisrLoader'
import classNames from 'classnames'

const Widget = ({ children, fetching, height, style, version }) => (
  <div
    className={classNames('jisr-widget', version && `jisr-widget--${version}`)}
    style={{ minHeight: height, ...style }}
  >
    {fetching && <JisrLoader absolute />}
    {children}
  </div>
)

Widget.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  fetching: PropTypes.bool,
  height: PropTypes.string,
  version: PropTypes.string,
  style: PropTypes.shape(),
}

export default Widget
